import React from "react";

export const NumberOfSelectedItems = ({
  numSelected,
  numTotal,
  onSelectAll,
  onDeselectAll,
}: {
  numSelected: number;
  numTotal: number;
  onSelectAll: () => void;
  onDeselectAll: () => void;
}) => {
  const handleSelectAll = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    onSelectAll();
  };

  const handleDeselectAll = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    onDeselectAll();
  };

  return (
    <div className="genomes-table-container__num-selected">
      {numSelected} out of {numTotal} selected (<a onClick={handleSelectAll}>Select All</a> /{" "}
      <a onClick={handleDeselectAll}>Deselect All</a>).
    </div>
  );
};
